import { render, staticRenderFns } from "./CuitResult.vue?vue&type=template&id=39b89fa9&"
import script from "./CuitResult.vue?vue&type=script&lang=js&"
export * from "./CuitResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports